
import { Component, Vue, Watch } from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import { getCustomerInInventory, getChangeHistory } from "@/api/closing-order";
import { searchCustomer } from "@/api/customer";
import { Message } from "element-ui";
import { exportJson2Excel } from "@/utils/excel";
import { formatJson } from "@/utils";
import { deepClone } from "@/utils/deepClone";
import { putGuestsInStockRemark } from "@/api/inquiry"
import { remark } from "@/api/purchase-order";
@Component({
  name: "guestsInStock",
  components: {
    Pagination,
  },
})
export default class extends Vue {
  private showAll = false;
  private showUpdateHistary = false;
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any,
  };
  private listParam = {
    customerId: null,
    displayNumber: null,
    productName: null,
  };
  private searchForm = [
    {
      label: "客人简称或编号",
      prop: "customerId",
      key: "customerId",
      type: "select",
      value: "",
      placeholder: "",
      remote: true,
      remote_method: this.searchCustomer,
      clearable: true,
      options: [],
      resetKey: { label: "abbreviation", value: "id" },
    },
    {
      label: "号码查询",
      prop: "displayNumber",
      key: "displayNumber",
      type: "input",
      value: "",
    },
    {
      label: "华强品名",
      prop: "productName",
      key: "productName",
      type: "input",
      value: "",
    },
    {
      label: "查询全部",
      prop: "all",
      key: "all",
      type: "select",
      placeholder: "否",
      value: "",
      options:  [
        { name: "否", id: false },
        { name: "是", id: true },
      ],
    },
  ];
  private updateHistaryList = [];
  private updateHistaryListCol = [
    {
      label: "变更前数量",
      prop: "quantityBeforeChange",
      key: "quantityBeforeChange",
      show: true,
      disabled: false,
    },
    {
      label: "变更数量",
      prop: "quantityChange",
      key: "quantityChange",
      show: true,
      disabled: false,
    },
    {
      label: "变更后数量",
      prop: "quantityAfterChange",
      key: "quantityAfterChange",
      show: true,
      disabled: false,
    },
    {
      label: "处理时间",
      prop: "createdTime",
      key: "createdTime",
      show: true,
      disabled: false,
    },
    {
      label: "变更原因",
      prop: "category",
      key: "category",
      type: "noCheckLink",
      show: true,
      disabled: false,
    },
    {
      label: "单据号码",
      prop: "code",
      key: "code",
      show: true,
      disabled: false,
    },
  ];
  private tableCol = [
    {
      label: "SKU",
      prop: "sku",
      key: "sku",
      show: true,
      disabled: false,
    },
    {
      label: "客人号码",
      prop: "c1",
      key: "c1",
      show: true,
      disabled: false,
    },
    {
      label: "客人号码2",
      prop: "c2",
      key: "c2",
      show_key: "show1",
      disabled: false,
    },
    {
      label: "HQ号码",
      prop: "hq",
      key: "hq",
      show_key: "show1",
      disabled: false,
    },
    {
      label: "OE号码",
      prop: "oe",
      key: "oe",
      show_key: "show1",
      disabled: false,
    },
    {
      label: "REF",
      prop: "ref",
      key: "ref",
      show_key: "show1",
      disabled: false,
    },
    {
      label: "华强品名",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false,
    },
    {
      label: "采购订单号",
      prop: "purchaseOrderCode",
      key: "purchaseOrderCode",
      show: true,
      disabled: false,
    },
    {
      label: "采购单价",
      prop: "purchaseUnitPrice",
      key: "purchaseUnitPrice",
      show: true,
      disabled: false,
    },
    {
      label: "折扣",
      prop: "purchaseDiscount",
      key: "purchaseDiscount",
      show: true,
      disabled: false,
    },
    {
      label: "折后单价",
      prop: "purchaseDiscountUnitPrice",
      key: "purchaseDiscountUnitPrice",
      show: true,
      disabled: false,
    },
    {
      label: "可用库存数量",
      prop: "availableQuantity",
      key: "availableQuantity",
      show: true,
      disabled: false,
    },
    {
      label: "在库数量",
      prop: "inInventoryQuantity",
      key: "inInventoryQuantity",
      show: true,
      disabled: false,
    },
    {
      label: "交货进度",
      prop: "deliveryProcess",
      key: "deliveryProcess",
      show: true,
      disabled: false,
    },
    {
      label: "工厂简称",
      prop: "factoryName",
      key: "factoryName",
      show: true,
      disabled: false,
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
      type: "remark",
      show: true,
      disabled: false,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "查看变更历史",
          code: "",
          click: "handleUpdateHistray",
        },
      ],
      show: true,
      disabled: false,
      width: 200,
    },
  ] as any;
  private infoFields = [
    {
      label: "SKU",
      prop: "sku",
      key: "sku",
    },
    {
      label: "华强品名",
      prop: "hqProductName",
      key: "hqProductName",
    },
    {
      label: "实时库存",
      prop: "totalCustomerInventory",
      key: "totalCustomerInventory",
    },
  ] as any;
  private info = {} as any;
  created() {
    this.init();
  }
  private init() {
    // this.getList()
  }
  private async searchCustomer(name = "") {
    const res: any = await searchCustomer({ keyword: name });
    this.searchForm[0].options = res;
  }
  public loading: Boolean = false;
  private objHeader = {
    c1:"客人号码",
    c2:"客人号码2",
    hq:"HQ号码",
    oe:"OE号码",
    ref:"REF"
  }
  private async getList() {
    this.loading = true;
    const params = {
      ...this.listParam,
      pageNumber: this.table.pageNumber,
      pageSize: this.table.pageSize,
    };
    const { total, list }: any = await getCustomerInInventory(params);
    this.table.total = +total;
    this.table.list = list;
    this.table.list.map(item => {
      item.purchaseDiscount = Number(item.purchaseDiscount) * 100 + '%';
    })
    if(this.table.list.length > 0) {
      this.table.list.map(e => {
        let newHeader = Object.keys(e.wrapperNumberUnits);
        newHeader.map(h => {
          if(e.wrapperNumberUnits[h]) {
            e[h] = e.wrapperNumberUnits[h];
          } else {
            e[h] = ''
          }
        })
      })
      // let newArr = newHeader.map(item => {
      //   return {
      //     label: this.objHeader[item],
      //     prop: item,
      //     key: item,
      //     value: "",
      //     show_key: item !== 'c1'?'show1':''
      //   } as any
      // })
      // let indexToArr = 1
      // if(this.tableCol.findIndex(e => e.key === "c1") === -1) {
      //   this.tableCol.splice.apply(this.tableCol, [indexToArr, 0].concat(newArr));
      // }
    }
    this.loading = false;
  }
  public querySearch(data) {
    this.listParam = Object.assign({}, data);
    this.listParam.customerId !== null
      ? this.getList()
      : Message.error("客人简称或编号不能为空");
  }

  private loadingHistory = false;
  private async handleUpdateHistray(e: any) {
    this.loadingHistory = true;
    this.showUpdateHistary = true;
    const { id, hqProductName,sku } = e.row;
    this.info.sku = sku;
    this.info.hqProductName = hqProductName;
    await getChangeHistory(id).then((res:any) => {
      this.$set(this.info,'totalCustomerInventory',res.totalCustomerInventory)
      this.updateHistaryList = res.changeHistory;
      this.updateHistaryList.map(item => {
        if(item.quantityBeforeChange < item.quantityAfterChange) {
          item.quantityChange = `+${item.quantityChange}`
        } else if(item.quantityBeforeChange > item.quantityAfterChange) {
          item.quantityChange = `-${item.quantityChange}`
        }
      })
      this.loadingHistory = false;
    }).catch(err => {
      console.log(err);
    })
  }
  private isExporting = false;
  private handleExport() {
    this.isExporting = true;
    let table = this.tableCol.slice(0, this.tableCol.length - 1);
    const headers = table.map((v) => v.label);
    const fieldNames = table.map((v) => v.key);
    let list = deepClone(this.table.list);
    exportJson2Excel(
      headers,
      formatJson(fieldNames, list),
      `客人在库-${new Date()}`
    );
    this.isExporting = false;
  }
  private async handleRemark(item) {
    let data = {
      remark: item.remark
    }
    await putGuestsInStockRemark(item.id,data).then(res => {
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000
      });
      this.getList();
    }).catch(err => {
      console.log(err);
    })
  }
  private linkClick(row) {
    this.showUpdateHistary = false;
    switch (row.row.category) {
      case "平仓":
        this.$router.push(`/closingPositionManagementInfo?code=${row.row.code}`);
        break;
      case "被使用":
      this.$router.push(`/salesOrder?piCode=${row.row.code}`);
        break;
      case "入库":
      this.$router.push(`/hq-packing-list?code=${row.row.code}`);
        break;
      default:
        this.$message.error('未定义的变更原因！')
    }
  }
}
